import React from "react";
import "./StatsSection.css";

const statsData = [
  { value: "200K+", label: "Travelers booked" },
  { value: "1.2M+", label: "Hotels worldwide" },
  { value: "120+", label: "Countries served" },
  { value: "60+", label: "Supported currencies" },
];

const StatsSection = () => {
  return (
    <section className="stats-section">
      <h2 className="stats-title">Our Impact in Numbers</h2>
      <div className="stats-grid">
        {statsData.map((stat, index) => (
          <div className="stat-card" key={index}>
            <span className="stat-value">{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
      <div className="stats-bg-circle circle1"></div>
      <div className="stats-bg-circle circle2"></div>
    </section>
  );
};

export default StatsSection;
